// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a292eb51687a45cfecfc","655":"2bf8b417726d18f63855"}[chunkId] + ".js";
};